/*
 * -----------------------------------------------------------------------
 *  <copyright file="import-crfs.tsx" company="Triumph Research Intelligence">
 *      Copyright (C) 2019 by Triumph Research Intelligence. All rights reserved.
 *  </copyright>
 * -----------------------------------------------------------------------
 */

import { checkData, checkLine, readString, readBool } from 'utils/importers/helpers';
import doImport from 'utils/importers/import-file';

const importCrfs = (data: any) => {
    const crfs: any = [];
    const errors: any = [];

    if (!checkData(data, errors)) return { data: [], errors };

    data.forEach((line: any, index: number) => {
        if (!checkLine(line, index, errors)) return;

        const initialErrorCount = errors.length;

        const active = readBool('Active', line, 0, index + 1, errors);
        const required = readBool('Required', line, 1, index + 1, errors);
        const subjectCode = readString('Source System ID', line, 2, index + 1, errors, 30, true);
        const crfName = readString('Name', line, 3, index + 1, errors, 60, true);

        // If there are any errors through this, then don't add the crf
        if (errors.length !== initialErrorCount) return;

        crfs.push({
            id: null,
            active,
            required,
            subjectCode,
            crfName,
        });
    });

    return { data: crfs, errors };
};

export default (file: any) => doImport({ file, importer: importCrfs });
